import styled from 'styled-components';
export const List = styled.div `
  padding: 4px 0;
  height: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;
export const Item = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
`;
